// Mock data for portfolio projects
export const portfolioProjects = [
  {
    title: 'Beverage and Lifestyle',
    category: 'CREATIVE DIRECTION',
    image: 'https://images.unsplash.com/photo-1519408469771-2586093c3f14?w=800&q=80',
    isCarousel: true,
    carouselImages: [
      '/images/beverage-lifestyle/image1.webp',
      '/images/beverage-lifestyle/image2.webp',
      '/images/beverage-lifestyle/image3.webp',
      '/images/beverage-lifestyle/image14.png',
      '/images/beverage-lifestyle/image4.webp',
      '/images/beverage-lifestyle/image5.webp',
      '/images/beverage-lifestyle/image6.webp',
      '/images/beverage-lifestyle/image7.webp',
      '/images/beverage-lifestyle/image8.webp',
      '/images/beverage-lifestyle/image9.webp',
      '/images/beverage-lifestyle/image10.webp',
      '/images/beverage-lifestyle/image11.webp',
      '/images/beverage-lifestyle/image12.webp',
      '/images/beverage-lifestyle/image13.webp'
    ],
    imageTitles: [
      'Strange Water',
      'MEXXO Tequila x Strange Water',
      'YRBA HARD X Raw Cuts',
      'Papi Steak',
      'Strange Water',
      'Juliette',
      'Joe And The Juice',
      'YRBA Hard x Raw Cuts',
      'Juliette',
      'YRBA Hard x Raw Cuts',
      'YRBA Hard',
      'Joe And The Juice - Juicy Beats Tour ft. Adriatique',
      'Joe And The Juice - Juicy Beats Tour ft. Adriatique',
      'Joe And The Juice - Juicy Beats Tour ft. Adriatique'
    ]
  },
  {
    title: 'Brand Activations',
    category: 'BRAND DESIGN',
    image: 'https://images.pexels.com/photos/29152435/pexels-photo-29152435.jpeg?w=800&q=80',
    isVideoCarousel: true,
    carouselVideos: [
      '/videos/brand-activations/don-julio-popup.mp4',
      '/videos/brand-activations/jeans-v1.mp4',
      '/videos/brand-activations/leons-bagels.mov',
      '/videos/brand-activations/jj-popup-v3.mov'
    ],
    videoPosterImages: [
      '/images/video-posters/don-julio-poster.png',
      '/images/video-posters/jeans-poster.png',
      '/images/video-posters/leons-poster.png',
      '/images/video-posters/jj-poster.png'
    ],
    videoTitles: [
      'Don Julio presents Dom Dolla + John Summit',
      'Jeans X Because Music Album Release Party',
      "Leon's Bagels X Levity Pop-Up",
      'Joe And The Juice - Juicy Beats Tour'
    ]
  },
  {
    title: 'Event Recap',
    category: 'DIGITAL MARKETING',
    image: 'https://images.unsplash.com/photo-1607703703520-bb638e84caf2?w=800&q=80',
    isVideoCarousel: true,
    carouselVideos: [
      '/videos/event-recap/papi-steak-valentines.mp4',
      '/videos/event-recap/pegasus-cup.mp4',
      '/videos/event-recap/swan-brunch.mp4',
      '/videos/event-recap/marco-liv.mp4',
      '/videos/event-recap/risque-tokyo.mp4'
    ],
    videoPosterImages: [
      '/images/video-posters/papi-steak-poster.webp',
      '/images/video-posters/pegasus-cup-poster.webp',
      '/images/video-posters/swan-brunch-poster.webp',
      '/images/video-posters/marco-liv-poster.webp',
      '/images/video-posters/risque-tokyo-poster.png'
    ],
    videoTitles: [
      "Papi Steak-Valentine's Day Dinner",
      'LIV Lounge - Pegasus Cup',
      'Pharrell Williams Celebrity Brunch',
      'Marco Corolla at Club LIV',
      'Risque Tokyo After Movie'
    ]
  },
  {
    title: 'Multi-Camera',
    category: 'CAMPAIGN STRATEGY',
    image: 'https://images.unsplash.com/photo-1494253109108-2e30c049369b?w=800&q=80',
    isVideoCarousel: true,
    carouselVideos: [
      '/videos/multi-camera/silver-linings.mp4',
      '/videos/multi-camera/loco-multi.mov',
      '/videos/multi-camera/boat-party-multi.mov',
      '/videos/multi-camera/shahar-multi.mov',
      '/videos/multi-camera/cassian-multi.mov',
      '/videos/multi-camera/kaytranada-multi.mov'
    ],
    videoPosterImages: [
      '/images/video-posters/anotr-pacha.png',
      '/images/video-posters/loco-dice.webp',
      '/images/video-posters/kevin-boat.jpg',
      '/images/video-posters/shahar-edge.png',
      '/images/video-posters/cassian-99scott.jpg',
      '/images/video-posters/kaytranada-brooklyn.jpg'
    ],
    videoTitles: [
      'ANOTR at Pacha NYC',
      'Loco Dice B2B Joseph Capriati at Brooklyn Storehouse',
      'Kevin DeViers at Tek Support Boat Party',
      'Shahar at The Edge',
      'Cassian at 99 Scott',
      'Kaytranada at the Brooklyn Storehouse'
    ]
  },
  {
    title: 'Fashion and Lifestyle',
    category: 'VISUAL PRODUCTION',
    image: 'https://images.unsplash.com/photo-1621111848501-8d3634f82336?w=800&q=80',
    isCarousel: true,
    carouselImages: [
      '/images/fashion-lifestyle/image3.jpg',
      '/images/fashion-lifestyle/image7.jpg',
      '/images/fashion-lifestyle/image6.webp',
      '/images/fashion-lifestyle/image2.webp',
      '/images/fashion-lifestyle/image1.jpg',
      '/images/fashion-lifestyle/image4.webp',
      '/images/fashion-lifestyle/image5.jpg',
      '/images/fashion-lifestyle/image8.webp',
      '/images/fashion-lifestyle/image9.jpg',
      '/images/fashion-lifestyle/image10.jpg',
      '/images/fashion-lifestyle/image11.jpg'
    ]
  },
  {
    title: 'Health and Fitness',
    category: 'DIGITAL STRATEGY',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    isVideoCarousel: true,
    carouselVideos: [
      '/videos/health-fitness/muay-thai.mp4',
      '/videos/health-fitness/vinchenzo-back-day.mp4',
      '/videos/health-fitness/mountain-bike.mp4',
      '/videos/prevention-studio.mp4'
    ],
    videoPosterImages: [
      '/images/video-posters/muay-thai.jpg',
      '/images/video-posters/vinchenzo-back.jpg',
      '/images/video-posters/mountain-bike.jpg',
      '/images/video-posters/prevention-studio.jpg'
    ],
    videoTitles: [
      'Muay Thai',
      'Vinchenzo Back Day',
      'Mountain Biking',
      'Private Fitness Studio Commercial'
    ]
  },
  {
    title: 'Motion Graphics',
    category: 'MOTION DESIGN',
    image: 'https://images.unsplash.com/photo-1551269901-5c5e14c25df7?w=800&q=80',
    isVideoCarousel: true,
    carouselVideos: [
      '/videos/motion-graphics/cash-cash-flyer.mp4',
      '/videos/motion-graphics/piv-nyc-flyer.mp4',
      '/videos/motion-graphics/neon-alley.mp4',
      '/videos/motion-graphics/tmith-loop.mp4',
      '/videos/motion-graphics/waves-of-mind.mp4',
      '/videos/motion-graphics/tmith-logo-turbulent.mp4',
      '/videos/motion-graphics/kiuss-tell-flyer.mp4',
      '/videos/motion-graphics/itscuff-cover.mp4',
      '/videos/motion-graphics/system-integration.mp4',
      '/videos/motion-graphics/already-gone.mp4'
    ],
    videoPosterImages: [
      '/images/video-posters/cash-cash-custom.png',
      '/images/video-posters/piv-nyc.jpg',
      '/images/video-posters/neon-alley.jpg',
      '/images/video-posters/tmith-loop.jpg',
      '/images/video-posters/waves-mind.jpg',
      '/images/video-posters/tmith-turbulent.jpg',
      '/images/video-posters/kiuss-tell.jpg',
      '/images/video-posters/itscuff.jpg',
      '/images/video-posters/system-integration.jpg',
      '/images/video-posters/already-gone-custom.webp'
    ],
    videoTitles: [
      'Cash Cash Flyer Animation',
      'PIV NYC Flyer Animation',
      'Neon Alley',
      'TMITH Tour Visuals Loop',
      'Waves of Mind Animation',
      'TMITH Logo Turbulent Displace',
      'Kiuss And Tell Flyer Animation',
      'ITSCUFF Animated Cover',
      'System Integration Animation',
      'Already Gone'
    ]
  },
  {
    title: 'Graphic Design',
    category: 'GRAPHIC DESIGN',
    image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800&q=80',
    isCarousel: true,
    carouselImages: [
      '/images/graphic-design/image1.jpg',
      '/images/graphic-design/image2.jpg',
      '/images/graphic-design/image3.png',
      '/images/graphic-design/image4.png',
      '/images/graphic-design/image5.webp',
      '/images/graphic-design/image6.jpg',
      '/images/graphic-design/image7.jpg',
      '/images/graphic-design/image8.png',
      '/images/graphic-design/irie-instagram.png',
      '/images/graphic-design/booby-nice-cover.jpg',
      '/images/graphic-design/blugenix-instagram.webp',
      '/images/graphic-design/art-basel-flyer.jpg'
    ],
    imageTitles: [
      'Album Cover',
      'Flyer Design',
      'Product Ad',
      'Facebook Ad',
      'Hormone Replacement Therapy Ad',
      'Radio Show Cover',
      'Record Cover',
      'Social Platform Resize',
      'Club Event Flyer',
      'Album Cover',
      'Instagram Design Strategy',
      'Art Basel Flyer Design'
    ]
  },
  {
    title: 'Wedding and Engagement',
    category: 'WEDDING & PROPOSAL',
    image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
    isCarousel: true,
    carouselImages: [
      '/images/wedding-engagement/image4-church-ceremony.webp',
      '/images/wedding-engagement/image7-couple-veil.jpeg',
      '/images/wedding-engagement/image6-wedding-party.jpg',
      '/images/wedding-engagement/image5-matt-mia.webp',
      '/images/wedding-engagement/image1-sepia.webp',
      '/images/wedding-engagement/image2-mic07822.webp',
      '/images/wedding-engagement/image3-mic07769.webp',
      '/images/wedding-engagement/image8-bride-forest.webp',
      '/images/wedding-engagement/image9-rooftop-kiss.webp',
      '/images/wedding-engagement/image10-engagement-emotion.webp',
      '/images/wedding-engagement/image11-ceremony-kiss.webp',
      '/images/wedding-engagement/image12-ring-roses.png'
    ],
    imageTitles: [
      'Ceremony Embrace',
      'Bridal Elegance',
      'Wedding Celebration',
      'First Look',
      'Cake Cutting',
      'The Ring',
      'She Said Yes',
      'Bridal Portrait',
      'Rooftop Romance',
      'Engagement Moment',
      'First Kiss',
      'Forever Begins'
    ]
  },
  {
    title: 'Promotional and Lifestyle',
    category: 'CONTENT PRODUCTION',
    image: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800&q=80',
    isVideoCarousel: true,
    carouselVideos: [
      '/videos/promotional-lifestyle/la-trip.mov',
      '/videos/promotional-lifestyle/keysh-color.mp4',
      '/videos/promotional-lifestyle/yellowstone.mov',
      '/videos/promotional-lifestyle/risque-coney-island.mov',
      '/videos/promotional-lifestyle/ibiza-vertical.mp4',
      '/videos/promotional-lifestyle/jordan-brando-promo.mov',
      '/videos/promotional-lifestyle/brooklyn-baby.mov',
      '/videos/promotional-lifestyle/shahar-carl-cox.mov',
      '/videos/promotional-lifestyle/refuge.mp4',
      '/videos/promotional-lifestyle/kiss-and-tell-mink-bday.mp4'
    ],
    videoPosterImages: [
      '/images/video-posters/la-trip.jpg',
      '/images/video-posters/keysh-color.jpg',
      '/images/video-posters/yellowstone.jpg',
      '/images/video-posters/risque-coney-island.jpg',
      '/images/video-posters/ibiza-vertical.jpg',
      '/images/video-posters/jordan-brando-promo.jpg',
      '/images/video-posters/brooklyn-baby.jpg',
      '/images/video-posters/shahar-carl-cox.jpg',
      '/images/video-posters/refuge.jpg',
      '/images/video-posters/kiss-and-tell-mink-bday.jpg'
    ],
    videoTitles: [
      'LA Trip',
      'Noches en Centro',
      'Yellowstone Adventure',
      'Risque Coney Island Promo',
      'Ibiza Lifestyle',
      'Jordan Brando Song Release Promo',
      'Brooklyn Baby',
      'Shahar Carl Cox Aftermovie',
      'Refuge Flyer Promo',
      'Kiss and Tell Promo'
    ]
  }
];

// Mock data for experience
export const experienceData = [
  {
    company: 'GROOT HOSPITALITY',
    role: 'Creative / Media Curator',
    period: '2021 - 2023',
    responsibilities: [
      'Developed and executed creative content across social and digital channels, supporting growth of brand presence across high-traffic hospitality venues.',
      'Directed 20+ on-site productions annually, managing talent, locations, and creative execution.',
      'Contributed to consistent audience growth and increased engagement (~20-30%) across social platforms through high-quality, brand-aligned content.',
      'Collaborated with marketing and design teams to elevate storytelling across multiple properties and campaigns.',
      'Produced content supporting venues with high-volume weekly foot traffic, strengthening brand visibility and cultural relevance.'
    ]
  },
  {
    company: 'TEK SUPPORT & RISQUE STUDIOS NYC',
    role: 'Creative Production Lead (Photography & Visual Content)',
    period: '2022 - Present',
    responsibilities: [
      'Directed and produced 50+ content assets monthly across multiple client accounts, including photography, video, and branded media.',
      'Led teams of creatives and freelancers to execute integrated campaigns across digital and social platforms.',
      'Built scalable production systems that improved delivery timelines by ~20-25%.',
      'Managed full production lifecycle from concept through post-production, ensuring high-quality and timely delivery.',
      'Expanded content capabilities by producing and editing podcast and audio content for brand storytelling.'
    ]
  }
];